import Launcher from "src/requests/apa/Launcher";
import AbstractRequestTask from "../AbstractRequestTask";

class LandingTask extends AbstractRequestTask {
  constructor(version = 'v1') {
    super();
    this.version = version;
    this.retriesNumer = 0;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS
    delete params.api_version
    delete params.format
    delete params.user_token
    delete params.device_so
    delete params.device_name
    return params
  }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/landing/${this.version}/content`;
    }
}
export default LandingTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/landingTelmex/LandingTask.js